<template>
  <div class="box">
    <div v-show="showAdd" class="operate" @click="handleOperate(index, 'add')">{{ '+' }}</div>
    <div class="commission-rule">
      <div v-for="(item, index) in commissionRuleList" :key="index" class="commission-rule-item">
        <el-select
          v-model="item.ruleDepartmentNo"
          placeholder="请选择部门"
          filterable
          clearable
          class="select-item"
          @change="(val) => handleDepartment(val, item, index)"
        >
          <el-option
            v-for="item in departmentList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="item.roleNo"
          placeholder="请选择角色"
          filterable
          clearable
          class="select-item"
          @change="(val) => handleRole(val, item, index)"
        >
          <el-option
            v-for="item in item.roleList"
            :key="item.roleNo"
            :label="item.roleName"
            :value="item.roleNo"
          ></el-option>
        </el-select>
        <el-select
          v-model="item.monthNumber"
          placeholder="请选择"
          filterable
          clearable
          class="select-item"
        >
          <el-option
            v-for="item in monthList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <span class="text">租金的</span>
        <el-input-number
          v-model="item.percentage"
          :precision="precision"
          :max="99.99"
          :min="0.0"
        ></el-input-number>
        <span class="text">%</span>
        <div v-if="index === 0">
          <span class="operate" @click="handleOperate(index, 'add')">{{ '+' }}</span>
          <span class="operate" @click="handleOperate(index, 'delete')">{{ '-' }}</span>
        </div>
        <div v-else>
          <span class="operate" @click="handleOperate(index, 'delete')">{{ '-' }}</span>
        </div>

        <!-- <span class="operate" @click="handleOperate(index)">{{ index === 0 ? '+' : '-' }}</span> -->
      </div>
    </div>
  </div>
</template>

<script>
  import XEUtils from 'xe-utils';
  import API from '@/api/intermodality/commission';
  export default {
    name: 'commissionRule',
    props: ['departmentList', 'editId', 'detailCommissionRuleList'],
    data() {
      return {
        commissionRuleList: [
          {
            ruleDepartmentName: '',
            ruleDepartmentNo: '',
            roleName: '',
            roleNo: '',
            monthNumber: '',
            percentage: '',
            roleList: [],
          },
        ],
        monthList: [
          { label: '1个月', value: '1' },
          { label: '2个月', value: '2' },
          { label: '3个月', value: '3' },
          { label: '4个月', value: '4' },
          { label: '5个月', value: '5' },
          { label: '6个月', value: '6' },
          { label: '7个月', value: '7' },
          { label: '8个月', value: '8' },
          { label: '9个月', value: '9' },
          { label: '10个月', value: '10' },
          { label: '11个月', value: '11' },
          { label: '12个月', value: '12' },
        ],
        precision: 2,
      };
    },
    computed: {
      showAdd() {
        return this.commissionRuleList.length === 0 ? true : false;
      },
    },
    methods: {
      handleOperate(index, val) {
        if (val === 'add') {
          // 添加
          this.commissionRuleList.unshift({
            ruleDepartmentName: '',
            ruleDepartmentNo: '',
            roleName: '',
            roleNo: '',
            monthNumber: '',
            percentage: '',
            roleList: [],
          });
        } else {
          this.commissionRuleList.splice(index, 1);
        }
      },
      handleDepartment(val, item) {
        item.roleNo = '';
        item.roleList = [];
        item.ruleDepartmentName = this.transferSelect(val, this.departmentList);
        // 获取部门下的角色
        if (val) {
          this.$axios.get(`${API.ROLE_BY_DEPARTMENTCODE}/${val}`).then((res) => {
            if (res.data.code === 0) {
              item.roleList = res.data.data || [];
            }
          });
        }
      },
      handleRole(val, item) {
        item.roleName = this.transferSelect(val, item.roleList, 'roleNo', 'roleName');
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .box {
    display: flex;
    flex-direction: row;
  }
  .commission-rule {
    display: flex;
    flex-direction: column;
    .commission-rule-item {
      display: flex;
      flex-direction: row;
      margin-bottom: 14px;
    }
  }
  .select-item {
    margin-left: 10px;
    width: 140px;
  }
  .text {
    margin: 0 10px;
  }
  .operate {
    margin: 0 20px;
    cursor: pointer;
    font-size: 24px;
  }
</style>
